// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"770":"routes","995":"collects-create"}[chunkId] + "." + {"770":"cc1deb5c","995":"3fc6e88b"}[chunkId] + ".css";
};